(() => {
  if (window.fwEducationTrackingInstalled) return;
  window.fwEducationTrackingInstalled = true;
  const tag = 'G-55JJZNH0NC';
  const allowedEvents = new Set(['article_product_click','quiz_start','quiz_complete','quiz_product_click','routine_preview_click']);
  const cleanPath = value => { try { const u = new URL(value, location.href); return u.origin === location.origin ? u.pathname : ''; } catch { return ''; } };
  const permitted = () => { try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; } };
  let started = false;
  let completed = false;
  const qa = new URLSearchParams(location.search).get('fw_tracking_qa') === '1';
  const log = message => { if (qa) { const out = document.querySelector('#fw-tracking-status'); if(out) out.textContent += '\n' + message; } };
  function send(name, params = {}) {
    if (!allowedEvents.has(name)) return false;
    if (!permitted()) { log(name + ': blocked by analytics consent'); return false; }
    const payload = {...params,send_to:tag,page_location:location.origin + location.pathname,page_referrer:cleanPath(document.referrer),transport_type:'beacon',event_callback:()=>log(name + ': Google tag processed'),event_timeout:1500};
    let attempts = 0;
    const deliver = () => {
      if (!permitted()) { log(name + ': cancelled after consent change'); return; }
      if (typeof window.gtag === 'function' && document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        window.gtag('event', name, payload);
        log(name + ': sent once through existing Google tag');
      } else if (++attempts < 30) setTimeout(deliver,100);
      else log(name + ': existing Google tag unavailable; event dropped');
    };
    deliver();
    return true;
  }
  document.addEventListener('click', event => {
    const a = event.target.closest?.('a[href]');
    if (!a) return;
    const productPath = cleanPath(a.href);
    if (!/\/products\/[^/]+/.test(productPath)) return;
    const params = {product_path:productPath};
    if (a.closest('.article__content,.fw-editorial-reading')) send('article_product_click', {...params,article_path:location.pathname});
    else if (a.closest('.fw-routine-quiz__preview')) send('routine_preview_click',params);
    else if (/\/pages\/your-fwbeauty-routine\/?$/.test(location.pathname) && a.closest('#MainContent')) send('quiz_product_click',params);
  },true);
  function inspect() {
    if (document.querySelector('.tangent_question_screen_custom') && !started) { started = true; send('quiz_start',{quiz_name:'fwbeauty_routine'}); }
    if (completed || !/\/pages\/your-fwbeauty-routine\/?$/.test(location.pathname)) return;
    const response = new URLSearchParams(location.search).get('resp_id');
    if (!response || !document.querySelector('#MainContent a[href*="/products/"]')) return;
    completed = true;
    if (!permitted()) { log('quiz_complete: blocked by analytics consent'); return; }
    const key = 'fw_quiz_completed_' + response;
    try { if (sessionStorage.getItem(key)) { log('quiz_complete: duplicate results reload suppressed'); return; } } catch {}
    if (send('quiz_complete',{quiz_name:'fwbeauty_routine'})) { try { sessionStorage.setItem(key,'1'); } catch {} }
  }
  let scheduled = false;
  new MutationObserver(() => { if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;inspect();}); }).observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
  document.addEventListener('visitorConsentCollected',()=>{log('Analytics allowed: ' + permitted());});
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});
  if (qa) {
    const panel=document.createElement('aside');
    panel.id='fw-tracking-qa';
    panel.style.cssText='position:fixed;bottom:12px;left:12px;z-index:2147483647;background:white;border:2px solid #590909;color:#222;padding:12px;max-width:420px;font:13px Arial';
    panel.innerHTML='<strong>FWBEAUTY tracking test</strong><p>Changes consent for this browser only.</p><button type="button" id="fw-qa-accept">Accept analytics for test</button> <button type="button" id="fw-qa-decline">Decline analytics for test</button><pre id="fw-tracking-status" style="white-space:pre-wrap;max-height:180px;overflow:auto"></pre>';
    document.body.appendChild(panel);
    const set = value => { const p=window.Shopify?.customerPrivacy;if(!p){log('Privacy API not ready');return;}p.setTrackingConsent({analytics:value,marketing:false,preferences:false},()=>log('Analytics allowed: '+permitted())); };
    panel.querySelector('#fw-qa-accept').addEventListener('click',()=>set(true));
    panel.querySelector('#fw-qa-decline').addEventListener('click',()=>set(false));
    log('Analytics allowed: '+permitted());
  }
  inspect();
})();
